import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgPlus = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 14a.875.875 0 0 1-.875.875h-8.75v8.75a.875.875 0 1 1-1.75 0v-8.75h-8.75a.875.875 0 0 1 0-1.75h8.75v-8.75a.875.875 0 0 1 1.75 0v8.75h8.75A.875.875 0 0 1 24.5 14Z" />
  </svg>
);
export default SvgPlus;
